var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c(
      "div",
      {
        staticClass:
          "panel bg-transparent columns large-6 medium-12 large-centered text-center",
      },
      [
        _vm.componentReady
          ? _c(
              "div",
              [
                _c(
                  "keep-alive",
                  [
                    _c(_vm.tabComponents[_vm.tabIndex], {
                      tag: "component",
                      attrs: { "display-data": _vm.displayData },
                      on: {
                        "display-change": function (val) {
                          return (_vm.displayData = val)
                        },
                        "tab-change": _vm.tabChanged,
                        complete: function ($event) {
                          return _vm.$emit("stage-change", 2)
                        },
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        !_vm.componentReady
          ? _c("div", [_c("i", { staticClass: "fa fa-spinner fa-spin fa-2x" })])
          : _vm._e(),
        _vm._v(" "),
        _vm.showGeNotice
          ? _c(
              "modal",
              {
                staticClass: "ge-notification-modal",
                attrs: { size: "medium", "show-close-button": true },
                on: {
                  close: function ($event) {
                    _vm.showGeNotice = false
                  },
                },
              },
              [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "medium-4 columns" }, [
                    _c("img", {
                      staticClass: "ge-notice-icon",
                      attrs: { src: _vm.geImg },
                    }),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "medium-8 text-left columns ge-notice-text",
                    },
                    [
                      _c("p", {
                        domProps: {
                          textContent: _vm._s(
                            _vm.t("register.ge_admin_congratulations")
                          ),
                        },
                      }),
                      _vm._v(" "),
                      _c("ul", [
                        _c("li", {
                          domProps: {
                            textContent: _vm._s(
                              _vm.t("register.ge_admin_bulletin1")
                            ),
                          },
                        }),
                        _vm._v(" "),
                        _c("li", {
                          domProps: {
                            textContent: _vm._s(
                              _vm.t("register.ge_admin_bulletin2")
                            ),
                          },
                        }),
                        _vm._v(" "),
                        _c("li", {
                          domProps: {
                            textContent: _vm._s(
                              _vm.t("register.ge_admin_bulletin3")
                            ),
                          },
                        }),
                      ]),
                      _vm._v(" "),
                      _c("p", {
                        domProps: {
                          textContent: _vm._s(
                            _vm.t("register.ge_admin_payment")
                          ),
                        },
                      }),
                      _vm._v(" "),
                      _c("p", {
                        domProps: {
                          textContent: _vm._s(
                            _vm.t("register.ge_admin_payment_complete")
                          ),
                        },
                      }),
                      _vm._v(" "),
                      _c("p", {
                        domProps: {
                          textContent: _vm._s(
                            _vm.t("register.ge_admin_payment_question")
                          ),
                        },
                      }),
                      _vm._v(" "),
                      _c("p", {
                        domProps: {
                          textContent: _vm._s(
                            _vm.t("register.ge_admin_welcome")
                          ),
                        },
                      }),
                      _vm._v(" "),
                      _c("p", { staticClass: "no-margin" }, [
                        _c("button", {
                          staticClass: "tiny",
                          domProps: {
                            textContent: _vm._s(
                              _vm.t("templates.page.IC_0001")
                            ),
                          },
                          on: {
                            click: function ($event) {
                              _vm.showGeNotice = false
                            },
                          },
                        }),
                      ]),
                    ]
                  ),
                ]),
              ]
            )
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }